<template lang="pug">
  transition(
    name="modal"
  )
    .modal-mask(
      @click="onClickMask($event)"
    )
      .modal-wrapper
        .modal.modal_confirm(
          @click="onClickWrapper($event)"
        )
          .modal__close
            //- button.modal-button-close(
            //-   @click="onCloseModal()"
            //- )
            //-   img(src="@/assets/images/icons/modal-button-close.svg")
          .modal__body
            .confirm
              .confirm__title(
                v-if="title"
              )
                h2.title {{ title }}
              .confirm__text.centrify {{ text }}
              .confirm__form
                form.form(
                  @submit.prevent="onSubmitMethod"
                )
                  .form__elem.form__elem_button
                    .form-elem
                      .form-elem__body
                        button.button.button_full(
                          @click.prevent="$emit('close')"
                        ) {{ buttonCancelText }}
                    .form-elem
                      .form-elem__body
                        button.button.button_paint-main.button_full(
                          @click.prevent="buttonConfirmFunc.func.apply(this, buttonConfirmFunc.params)"
                          @click="$emit('close')"
                          ) {{ buttonConfirmText }}
</template>

<script>
export default {
  name: "ConfirmModal",
  props: {
    title: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    buttonConfirmText: {
      type: String,
      default: "Да"
    },
    buttonCancelText: {
      type: String,
      default: "Нет"
    },
    buttonConfirmFunc: {
      func: {
        type: Function
      },
      params: {
        /*Аргумент ВСЕГДА передавать массивом, т.к. используется apply*/
        type: Array
      }
    }
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {
    onClickMask() {
      this.onCloseModal();
    },
    onClickWrapper(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    onCloseModal() {
      this.$emit("close");
    },
    onSubmitMethod(e) {
      e.preventDefault();
    }
  },
  mounted() {}
};
</script>
